import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { BuilderTypesDbKeys } from '@app/hcs-shared/expression';
import { Filter } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import './Editor_Precondition.scss';
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/editable-item';
import { ModuleFE_Expression } from '@app/hcs-frontend';
import { ModuleFE_Action } from '../../../../../../../_entity/action/index.js';
import { ModuleFE_OrderGroup } from '../../../../../../../_entity/order-group/index.js';
import { UtilObject_Action } from '../../../../../../../search/items/action.js';
import { UtilObject_OrderGroup } from '../../../../../../../search/items/order-group.js';
export class Editor_PreconditionTimeConstraint extends TS_EditableItemComponent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.insertExpressionId ??= !!state.editable.item.expressionId;
        return state;
    }
    //TODO: Bring it back when Shlomi wants it
    // private renderTimeConstraintEditor = () => {
    // 	if (!this.state.insertTimeConstraint)
    // 		return '';
    //
    // 	const editableTimeConstraint = this.state.editable.editProp('timeConstraint', {});
    // 	const editableTimeRange = editableTimeConstraint.editProp('timeRange', []) as EditableItem<TimeRange | [undefined, undefined]>;
    // 	return <LL_H_C className={'match_width'}>
    // 		<DropDown_PreconditionTimeConstraintIndex.editable
    // 			editable={editableTimeConstraint}
    // 			prop={'index'}
    // 		/>
    // 		<Editor_TimeRange editable={editableTimeRange}/>
    // 	</LL_H_C>;
    // };
    toggleTimeConstraint = () => {
        this.setState({ insertExpressionId: !this.state.insertExpressionId }, () => {
            if (!this.state.insertExpressionId)
                return this.state.editable.updateObj({ expressionId: undefined });
        });
    };
    renderExpressionDropdown = () => {
        if (!this.state.insertExpressionId)
            return '';
        const expression = ModuleFE_Expression.cache.unique(this.state.editable.item.expressionId);
        return _jsx(TS_DropDown, { adapter: SimpleListAdapter(ModuleFE_Expression.cache.allMutable(), item => _jsx(_Fragment, { children: item.item.label })), queryFilter: expression => BuilderTypesDbKeys.includes(expression.expressionType), limitItems: 20, placeholder: 'Select Expression', selected: expression, disabled: this.props.disabled, filter: new Filter(item => [item.label.toLowerCase()]), canUnselect: true, onSelected: async (expression) => {
                if (!expression) {
                    return this.state.editable.updateObj({ expressionId: undefined });
                }
                return this.state.editable.updateObj({ expressionId: expression._id });
            } });
    };
    render() {
        const Icon = this.state.insertExpressionId ? ICONS.x : ICONS.advisor_v5_plus;
        const disabled = this.props.disabled;
        return _jsxs(LL_V_L, { className: 'editor-precondition', children: [_jsxs(LL_H_C, { className: 'value-container', children: [this.render_PreconditionTitle(), !disabled && _jsx(Icon.component, { className: _className(!this.state.insertExpressionId && 'plus'), onClick: this.toggleTimeConstraint })] }), this.renderExpressionDropdown()] });
    }
    render_PreconditionTitle = () => {
        const pointer = this.state.editable.item.itemPointer;
        switch (pointer?.dbKey) {
            case DBDef_Action.dbKey: {
                const order = ModuleFE_Action.cache.unique(pointer.id);
                return _jsx("div", { className: 'order-title', onClick: e => {
                        e.stopPropagation();
                        UtilObject_Action.openEditor(pointer.id);
                    }, children: order?.name ?? 'N/A' });
            }
            case DBDef_OrderGroup.dbKey: {
                const group = ModuleFE_OrderGroup.cache.unique(pointer.id);
                return _jsx("div", { className: 'order-title', onClick: e => {
                        e.stopPropagation();
                        UtilObject_OrderGroup.openEditor(pointer.id);
                    }, children: group?.name ?? 'N/A' });
            }
        }
    };
}
//# sourceMappingURL=Editor_Preconditions.js.map